// Single source of truth for the year-specific bits of the admin panel.
// Bump NSSC_YEAR once at cycle start; every heading and archive list flows
// from here.

export const NSSC_YEAR = 2026;
export const PREV_NSSC_YEARS = [2025];
